/* eslint-disable import/prefer-default-export */
import { GET_USER_FAVORITES, GET_ADD_FAVORITES, GET_DELETE_FAVORITES } from '../../types/Types';

export const getUserFavorites = (data) => ({
  type: GET_USER_FAVORITES,
  data,
});
export const addUserFavorites = (data) => ({
  type: GET_ADD_FAVORITES,
  data,
});

export const deleteUserFavorite = (data) => ({
  type: GET_DELETE_FAVORITES,
  data,
});
